import React from 'react';

export const PWC_TEAM_BULK_ADD_HELPER =
  'Add team members one at a time, or use Bulk Add Users to paste multiple email addresses.';

export const CLIENT_TEAM_BULK_ADD_HELPER =
  'Add client users one at a time, or use Bulk Add Users to paste multiple email addresses.';

export const getBulkAddSuccessMessage = (count, createStep) =>
  `${count} user(s) added. Review roles and click ${createStep ? 'Next' : 'Save'} to ${createStep ? 'continue' : 'apply changes'}.`;

export const getBulkAddSaveHint = (createStep) =>
  createStep
    ? 'Valid users will be added to the table. Click Next to continue.'
    : 'Valid users will be added to the table. Click Save on the Settings page to apply changes.';

export const getBulkAddReportIssuePage = (createStep) =>
  createStep ? 'Create Project' : 'Project Settings';

const PWC_EMPLOYEE_TOOLTIP_KEYS = ['staffLevel', 'country', 'location'];

export const formatPwcEmployeeTooltip = (memberData) => {
  if (!memberData) {
    return null;
  }

  const values = PWC_EMPLOYEE_TOOLTIP_KEYS.map((key) => memberData[key]).filter(
    Boolean,
  );

  if (values.length === 0) {
    return null;
  }

  return (
    <div className="bulk-add-employee-tooltip">
      {values.map((value, index) => (
        <div key={index} className="bulk-add-employee-tooltip__row">
          {value}
        </div>
      ))}
    </div>
  );
};
